import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import { Button, TYPES } from "components/Button"
import { Link } from "react-router-dom"

export const FORMAT = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
}

class Ad extends React.Component {
  static defaultProps = {
    buttonText: "Läs mer",
    href: "#",
  }

  render() {
    const { image, title, body, adFormat } = this.props
    let { href } = this.props

    if (href && !href.startsWith("http")) {
      href = `http://${href}`
    }

    return (
      <div
        className={cx(
          styles.container,
          styles[adFormat || FORMAT.HORIZONTAL]
        )}
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className={styles.textWrapper}>
          <h2>{title}</h2>
          <p>{body}</p>

          <a href={href}>
            <Button buttonType={TYPES.SUCCESS}>
              {this.props.buttonText}
            </Button>
          </a>
        </div>
      </div>
    )
  }
}

export default Ad



// WEBPACK FOOTER //
// src/components/Ad/index.jsx